import { getConfig } from "@moodys/cre-cpm-client-apis.apis.api-base"
import { PlatformApi } from "@moodys/cre-cpm-client-apis.apis.services.platform"

/**
 * The default configuration for the app.
 */
const platformApi = new PlatformApi(getConfig({ url: process.env.REACT_APP_API_PLATFORM || "" }))

export default platformApi
